import React from 'react'
import { FieldProps } from 'react-jsonschema-form'

import { Body2 } from '../../utils/typography'

const DescriptionField = ({ description }: FieldProps) => {
  if (!description) return null
  return <Body2 mt={5}>{description}</Body2>
}

export default DescriptionField
